<a [routerLink]="['/tracker']" routerLinkActive="active">
  <span class="text">{{ 'Лікування' | translate }}</span>
</a>
